import React, { useMemo, useEffect } from "react";
import classNames from "classnames";
import ReactDOM from "react-dom";

import Cross from "../../assets/svg/Cross.jsx";
import { useBlockScroll } from "../../hooks";

import styles from "./FullModal.module.scss";

const FullModal = ({ children, className, close }) => {
  const root = useMemo(() => document.getElementById("full-modal"), []);

  const [blockScroll, allowScroll] = useBlockScroll();

  useEffect(() => {
    blockScroll();

    return () => {
      allowScroll();
    };
  });

  return !!root ? (
    ReactDOM.createPortal(
      <div className={styles.FullModal}>
        <div className={styles.Substrate}>
          <div className={classNames("wrap holder no-pdn-top", styles.Background)}>
            <div className={styles.Wrapper}>
              <header className={styles.Header}>
                <h1 className={styles.Title}>Начать проект</h1>

                <button className={styles.Button} aria-label="X" onClick={close}>
                  <Cross className={styles.Icon} />
                </button>
              </header>

              <div className={className}>{children}</div>
            </div>
          </div>
        </div>
      </div>,
      root
    )
  ) : (
    <></>
  );
};

export default FullModal;
